<template>
  <main class="container">
    <div class="exclamation">
      <ExclamationIcon class="icon" />
    </div>

    <h1 class="page-title">Oh Dear!</h1>

    <p>
      This house
      <template v-if="address"
        >at <span class="address">{{ address }}</span
        >&nbsp;</template
      >is already complete.<br />There’s nothing you need to do, please get in
      touch below if you think there’s an error.
    </p>

    <router-link class="btn btn--big btn--full-width" to="/">Back</router-link>

    <a href="https://www.unihomes.co.uk/contact" target="_blank">Contact Us</a>
  </main>
</template>

<script>
import ExclamationIcon from "@/assets/svg/icon-exclamation.svg";

export default {
  name: "AccountAlreadyComplete",
  props: {
    address: String,
  },
  created() {
    // ensure back btn is hidden
    this.$store.commit("HIDE_BACK_BTN");
  },
  components: {
    ExclamationIcon,
  },
};
</script>

<style lang="scss" scoped>
main {
  text-align: center;
}

.exclamation {
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 50%;
  background-color: $brand-blue;
  width: 100px;
  height: 100px;
  margin: $spacing-large auto 0 auto;

  .icon {
    fill: white;
    height: 67px;
    width: 25px;
  }
}

p {
  font-size: $subtitle-font-size;
  color: $grey-dark;

  .address {
    color: $brand-dark-blue;
    font-weight: $font-bold;
  }
}

a {
  font-size: $button-font-size;
  font-weight: $font-bold;
  color: $brand-dark-blue;
}
</style>
